import moduleStyles from "components/module/styles.module.css";

import { useMemo, useState, useCallback, use, useEffect }  from 'react';
import { ModuleProps } from "components/props/ModuleProps"
import { IconPicker } from "components/layout/icons/IconPicker";
import Spacer from "components/layout/Spacer";
import parse from 'html-react-parser';
import { Repository } from "./api/Repository";
import { ModuleOnline } from "components/module/ModuleOnline";
import { ModuleWithData } from "components/module/ModuleWithData";
import { useNavigate } from "react-router";
import { Module } from "./Module";

interface PromiseProps {
    count: number,
    dueCount: number,
}

const DefaultPromiseProps: PromiseProps = {
    count: 0,
    dueCount: 0
}

interface DashboardProps {
    refresh: boolean
}

export const Dashboard = ({ refresh }: DashboardProps ) => {

    const navigate = useNavigate();
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const fetchOnline = useCallback(async () => {
        const count = await Repository.getReadyForApprovalCountAsync();
        return {
            count: count.total,
            dueCount: count.due
        };
    }, []);

    const fetchData = useCallback((): Promise<PromiseProps> => {
        if (navigator.onLine) {
            return fetchOnline();
        } else {
            return Promise.resolve(DefaultPromiseProps);
        }
    }, [fetchOnline]);

    const dataPromise = useMemo(() => fetchData(), [fetchData, refreshTrigger]);

    const onClick = () => {
        navigate(Module.url);
    }

    useEffect(() => {
        if(!refresh) return;
        setRefreshTrigger(prev => prev + 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refresh]);

    return (
        <ModuleWithData
            module={Module}
            dataPromise={dataPromise}
            errorText="Kunne ikke hente fravær til godkjenning.">
            <DashboardContent
                onClick={onClick}
                dataPromise={dataPromise}
            />
        </ModuleWithData>
    )
}

interface DashboardContenttProps {
    dataPromise: Promise<PromiseProps>,
    onClick: (module: ModuleProps) => void;
}
const DashboardContent = ({
    dataPromise,
    onClick

}: DashboardContenttProps) => {
    const data = use<PromiseProps>(dataPromise);

    return (
        data &&
        <ModuleOnline module={Module}>
                <div className={moduleStyles.bar} onClick={onClick}>
                    <div className={moduleStyles.barContent}>
                    <div>
                        <div>{parse(Module.text)}</div>
                        {
                            (data.count > 0) &&
                                <>
                                    <Spacer height={5} />
                                        <div>Du har {data.dueCount}/{data.count} frav&aelig;r til godkjenning</div>
                                </>
                        }
                    </div>
                    <div><IconPicker icon={Module.icon} size={24} /></div>
                </div>
            </div>
        </ModuleOnline>
    )
}
